import UserGroupUsersConnected from './UserGroupUsersConnected'

export default UserGroupUsersConnected
